import { Box } from 'src/design/atoms/Box';
import { Container } from 'src/design/atoms/Container';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';
import React from 'react';

/**
 * Public, unauthenticated privacy notice. Rendered at /legal/privacy without
 * MSAL — required as the publicly-reachable privacy policy URL for SMS
 * campaign registration. Plain static content: no API calls, no auth, no
 * user context.
 */
export const Privacy: React.FC = () => {
  return (
    <Box style={{ minHeight: '100vh' }} bg="gray.0" py="xl">
      <Container size="sm">
        <Stack gap="md">
          <Title order={2}>Privacy Notice</Title>

          <Text size="sm">
            This notice describes how Firetrol handles phone numbers collected
            for the Firetrol Insite text messaging program.
          </Text>

          <Title order={4}>What we collect</Title>
          <Text size="sm">
            We collect and store the phone number you provide when opting in to
            text messages, solely to send you employee workflow notifications
            (such as timesheet submissions, approvals, rejections, and review
            requests) and phone verification codes.
          </Text>

          <Title order={4}>Where it's stored</Title>
          <Text size="sm">
            Your phone number is stored in our application database.
          </Text>

          <Title order={4}>How messages are delivered</Title>
          <Text size="sm">
            We use Azure Communication Services, a Microsoft product, as our
            delivery sub-processor for sending text messages. Message delivery
            through Azure Communication Services is governed by the Microsoft
            Data Protection Addendum (DPA).
          </Text>

          <Title order={4}>No sale or sharing</Title>
          <Text size="sm">
            We do not sell your phone number or any related data. Data collected
            as part of the opt-in text messaging program is never shared with
            third parties, except as described above for message delivery.
          </Text>

          <Title order={4}>Access and deletion</Title>
          <Text size="sm">
            To request access to or deletion of your phone number or related
            data, contact your Firetrol IT support channel.
          </Text>
        </Stack>
      </Container>
    </Box>
  );
};
